import { render, staticRenderFns } from "./PersonalId.vue?vue&type=template&id=1a8ae23e&scoped=true&"
import script from "./PersonalId.vue?vue&type=script&lang=js&"
export * from "./PersonalId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ae23e",
  null
  
)

export default component.exports